import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Pipe({
    name: 'exponent',
    standalone: false
})
export class ExponentPipe implements PipeTransform {


  /**
    * Transforms a numerical input into either a formatted string or an exponential notation string.
    *
    * - If `maxLength` is provided and the length of the whole part of the `value` is less than `maxLength`,
    *   the number is formatted using the standard numerical format.
    * - Otherwise, the number is converted to scientific (exponential) notation.
    *
    * @param {number} value - The number to be transformed.
    * @param {number} [decimalPlaces=2] - Optional. The number of decimal places in the output. Defaults to 2.
    * @param {number} [maxLength] - Optional. The maximum length of the the number before scientific notation is used
    *
    * @returns {string | number} - The transformed number as a formatted string or in exponential notation.
    */
  transform(value: number, decimalPlaces: number = 2, maxLength?: number): string | number {
    if (!value) {
      return value;
    }
    // Checking scientific notation will apply or not
    const roundedValue = Math.round(value);
    const valueLength = roundedValue.toString().length;

    if (maxLength && valueLength < maxLength) {
      if (Number.isInteger(value)) {
        return value;
      }
      const digitInfo = `.${decimalPlaces}-${decimalPlaces}`;
      const result = formatNumber(value, environment.preferredLanguage, digitInfo);
      return result;
    }

    // Return scientific notation value
    return value !== 0 ? value.toExponential(decimalPlaces) : value;
  }
}